package com.essntl.features.paymentparameter.ui.paymentparameter

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.features.paymentparameter.ui.paymentparameter.components.PaymentParameterItem
import com.essntl.uikit.components.button.primary.EsSmallPrimaryButton
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun PaymentParameterScreen(
    state: PaymentParameterState,
    onEvent: (PaymentParameterEvent) -> Unit,
    onNavigation: (PaymentParameterNavigation) -> Unit,
) {
    Column(
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.Start,
        modifier = Modifier.fillMaxWidth(0.5f),
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier.fillMaxWidth(),
        ) {
            Text(
                text = "Payment parameters",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.h4SemiBold20,
            )

            EsSmallPrimaryButton(
                text = "Add new",
                onClick = {
                    onNavigation(PaymentParameterNavigation.AddPaymentParameter)
                },
            )
        }

        Spacer(modifier = Modifier.height(2.spacing))

        if (state.getAllPaymentParameter.isLoading ||
            state.getAllPaymentParameter.isFailure
        ) Box(
            contentAlignment = Alignment.Center,
        ) {
            if (state.getAllPaymentParameter.isLoading)
                EsSpinner()
            else
                Text(
                    text = "Something goes wrong!",
                    color = MaterialTheme.esColorScheme.textSecondary,
                    style = MaterialTheme.esTypography.p1Medium16,
                )

        } else {
            if (state.getAllPaymentParameter.data.orEmpty().isEmpty())
                Box(
                    contentAlignment = Alignment.Center,
                ) {
                    Text(
                        text = "Nothing was found",
                        color = MaterialTheme.esColorScheme.textSecondary,
                        style = MaterialTheme.esTypography.p1Medium16,
                    )
                }
            else
                LazyColumn(
                    verticalArrangement = Arrangement.spacedBy(10.dp),
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    items(state.getAllPaymentParameter.data.orEmpty()) { p ->
                        PaymentParameterItem(
                            paymentParameter = p,
                            state = state,
                            onEvent = onEvent,
                            onNavigation = onNavigation,
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                }
        }
    }
}